import React from 'react';

const pukukoppiLa = () => {
  return (
    <div className="container">
        <div>
        <h4 className ='date-title'>Lauantai 17.05.2025</h4>
    <hr/>
      </div>
        <p style ={{paddingTop:'10px'}}>Pukukopit on joukkueilla käytössä koko turnauspäivän ajan. </p>
      <div className="table-container">
        
        <div className='lauantai-pukukoppijako'>
        <h3>U7 pukukoppijako</h3>
        <table className='ranking-table'
        >
          <thead>
            <tr>
              <th style ={{textAlign:'left'}}>Joukkue</th>
              <th style ={{textAlign:'left'}}>Koppi</th>
            </tr>
          </thead>
          <tbody>
            <tr>
            <td style ={{textAlign:'left'}}>
              <img src='https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png' 
              alt='Wolf logo' 
              className='pukukoppi-logo' />
              Wolf U7
            </td>
            <td style ={{textAlign:'left'}}> Ulkokoppi 3 </td>
            </tr>
            <tr>
              <td style ={{textAlign:'left'}}>
              <img src='https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg' 
              alt='HIFK Logo' 
              className='pukukoppi-logo'
           />
                HIFK U7 Red </td>
                <td style ={{textAlign:'left'}}>Iso Valmennus</td>
            </tr>
            <tr>
              <td style ={{textAlign:'left'}}>
              <img src='https://sportti.org/site/assets/files/1298/kurra-2023-original.webp' 
              alt='KurraLogo' 
              className='pukukoppi-logo' />
                Kurra U7 </td>
                <td style ={{textAlign:'left'}}> Koppi 1</td>
            </tr>
            <tr>
              <td style ={{textAlign:'left'}}> 
              <img src='https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg' 
              alt='HIFK Logo' 
              className='pukukoppi-logo'
             />
                HIFK U7 Grey/White/Blue </td>
                <td style ={{textAlign:'left'}}>Koppi 2</td>
            </tr>
           
            <tr>
              <td style ={{textAlign:'left'}}>
              <img src='https://static.jopox.fi/harjunkiekko/logos/logo-300.png' 
              alt='Haki Logo' 
              className='pukukoppi-logo' />
              Haki U7 </td>
              <td style ={{textAlign:'left'}}>Koppi 3</td>
            </tr>
            <tr>
              <td style ={{textAlign:'left'}}>
              <img src='https://kiekko-tiikerit.fi/wp-content/uploads/2020/12/tiikerit_logo_transparent_1600-1.png' 
              alt='Kiekko tiikerit Logo' 
              className='pukukoppi-logo' />
                Kiekko Tiikerit U7 </td>
                <td style ={{textAlign:'left'}}>Koppi 4  </td>
            </tr>
            
            
          </tbody>
        </table>
        </div>
      </div>

      <div className="table-container">
        <div className='lauantai-pukukoppijako'>
        <h3>U8 pukukoppijako</h3>
        <table className='ranking-table'>
          <thead>
            <tr>
              <th style ={{textAlign:'left'}}>Joukkue</th>
              <th style ={{textAlign:'left'}}>Koppi</th>
            </tr>
          </thead>
          <tbody>
          <tr>
             <td style ={{textAlign:'left'}}> 
              <img src='https://upload.wikimedia.org/wikipedia/fi/thumb/5/52/Kiekko-Vantaa_logo.svg/1200px-Kiekko-Vantaa_logo.svg.png' 
              alt='Kiekko Vantaa Logo' 
              className='pukukoppi-logo' />
              
                Kiekko Vantaa U8 </td>
              <td style ={{textAlign:'left'}}>Ulkokoppi 1</td>
            </tr>
            <tr>
              <td style ={{textAlign:'left'}}>
              <img src='https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png' 
              alt='Wolf logo' 
              className='pukukoppi-logo' />
                Wolf U8</td>
              <td style ={{textAlign:'left'}}> Ulkokoppi 2 </td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
              <img src='https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg' 
              alt='HIFK Logo' 
              className='pukukoppi-logo'/>
                HIFK U8 Blue </td>
              <td style ={{textAlign:'left'}}> Koppi 1</td>
            </tr>
            <tr>
              <td style ={{textAlign:'left'}}> 
              <img src='https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg' 
              alt='HIFK Logo' 
              className='pukukoppi-logo'/>
                HIFK U8 Red/White </td>
              <td style ={{textAlign:'left'}}>Koppi 2</td>
            </tr>    
           
            <tr>
            <td style ={{textAlign:'left'}}> 
              <img src='https://static.jopox.fi/harjunkiekko/logos/logo-300.png' 
              alt='Haki Logo' 
              className='pukukoppi-logo' />
                Haki U8</td>
              <td style ={{textAlign:'left'}}>Koppi 3</td>
            </tr>
            <tr>
            <td style ={{textAlign:'left'}}> 
              <img src='https://kiekko-tiikerit.fi/wp-content/uploads/2020/12/tiikerit_logo_transparent_1600-1.png' 
              alt='Kiekko tiikerit Logo' 
              className='pukukoppi-logo' />
                Kiekko Tiikerit U8 </td>
              <td style ={{textAlign:'left'}}>Koppi 4  </td>
            </tr>
          
          </tbody>
        </table>
        </div>
      </div>
      
    
      </div>
  );
};

export default pukukoppiLa;
